module.exports = __webpack_public_path__ + "img/user-doctor-message.e7ac719d.svg";